import {HealthDistrictsGuide} from 'domain/usecases/private/guide-flow/medical-guide/get-districts';
import {NeighborhoodsDentalGuide} from 'domain/usecases';
import {FlowType} from 'presentation/pages/private/store/locationStore/constants';
import {useDistrictsGuideQuery} from '../../queries/useDistrictsGuideQuery';
import {UseDistrictsQueryParams, UseDistrictsQueryReturn} from './types';
import {useHealthDistrictsGuideQuery} from 'presentation/modules/guide/health/queries/useHealthDistrictsGuideQuery';

export function useDistrictsQuery({
	flowType,
	healthParams,
	odontoParams,
}: UseDistrictsQueryParams): UseDistrictsQueryReturn {
	const healthQuery = useHealthDistrictsGuideQuery({
		...healthParams,
		enabled: flowType === FlowType.HEALTH_GUIDE && healthParams.enabled !== false,
	});

	const odontoQuery = useDistrictsGuideQuery({
		...odontoParams,
		enabled: flowType === FlowType.ODONTO_GUIDE && odontoParams.enabled !== false,
	});

	const normalizeOdontoToHealthFormat = (
		odontoData: NeighborhoodsDentalGuide[],
		uf?: string,
		cidade?: string,
	): HealthDistrictsGuide[] =>
		odontoData.map(item => ({
			uf: uf ?? '',
			cidade: cidade ?? '',
			bairro: item.nmBairro,
		}));

	if (flowType === FlowType.HEALTH_GUIDE) {
		return {
			data: healthQuery.data,
			isLoading: healthQuery.isFetching,
			isError: healthQuery.isError,
			error: healthQuery.error,
			refetch: healthQuery.refetch,
		};
	}

	if (flowType === FlowType.ODONTO_GUIDE) {
		const normalizedData = odontoQuery.data
			? normalizeOdontoToHealthFormat(
					odontoQuery.data,
					odontoParams.cdUf,
					odontoParams.nmCidade,
				)
			: undefined;

		return {
			data: normalizedData,
			isLoading: odontoQuery.isLoading,
			isError: odontoQuery.isError,
			error: odontoQuery.error,
			refetch: odontoQuery.refetch,
		};
	}

	return {
		data: undefined,
		isLoading: false,
		isError: false,
		error: null,
		refetch: () => Promise.resolve({} as unknown),
	};
}
